import _ from "lodash";
import { useState } from "react";
import * as propertyTypes from "../propertyTypes";
import { createRegex } from "../tiny-functions/createRegex";
import * as api from "core-module/services/api";
import { ApiError } from "../services/error";

function useDialogWebFormMultiItems(props, propNames) {
  const [input, setInput] = useState({});
  const [errorState, setErrorState] = useState({});
  const [initialized, setInitialized] = useState({});
  const [regex, setRegex] = useState({});
  const [formIsValid, setFormIsValid] = useState(true);
  // const [formErrorMessage, setFormErrorMessage] = useState("");
  const [helperText, setHelperText] = useState({});

  const pathname = props.pathname;
  const pathids = props.pathids;

  function validateField(value, propName, type) {
    if (getSchema(propName) == null) {
      return;
    }
    if (type === propertyTypes.OPEN_INPUT) {
      return regex[propName].test(value);
    } else if (type === propertyTypes.SELECT_OPTION) {
      for (let option of getSchema(propName).dropdownOptions) {
        if (Array.isArray(option)) {
          if (value === option[0] || value === option[2]) {
            return true;
          }
        } else {
          if (value === option) {
            return true;
          }
        }
      }
      return false;
    }
    if (type === propertyTypes.BOOLEAN) {
      if (value === true || value === false) {
        return true;
      } else {
        return false;
      }
    } else {
      throw new Error("Unknown type [" + type + "] on validateField");
    }
  }

  function getTitle() {
    return "";
  }

  function getError(propName) {
    return errorState[propName];
  }

  function getLabel(propName) {
    if (getSchema(propName) == null) {
      return;
    }
    return getSchema(propName).label;
  }
  function getErrorMessage(propName) {
    if (getSchema(propName) == null) {
      return;
    }
    return getSchema(propName).errorMessage;
  }
  function getValue(propName) {
    return input[propName];
  }
  function getTextInputValue(propName) {
    return getValue(propName) + "";
  }
  function getHelperText(propName) {
    return helperText[propName];
  }
  function getDropdownOptions(propName) {
    if (getSchema(propName) == null) {
      return;
    }
    return getSchema(propName).dropdownOptions;
  }

  function startForm() {
    const newInput = { ...input };
    const newErrorState = { ...errorState };
    const newInitialized = { ...initialized };
    const newRegex = { ...regex };
    const newHelperText = { ...helperText };

    for (let propName of propNames) {
      if (props.pathids.getData(propName, "value") !== "undefined") {
        newInput[propName] = pathids.getData(propName, "value");
      } else {
        newInput[propName] = "";
      }

      newErrorState[propName] = false;
      newInitialized[propName] = false;

      const schema = getSchema(propName);
      if (getSchema(propName).type === propertyTypes.OPEN_INPUT) {
        newRegex[propName] = createRegex(schema.regex);

        if (newRegex[propName].test(newInput[propName])) {
          setFormIsValid(true);
          newHelperText[propName] =
            schema.minLength.toString() +
            "-" +
            schema.maxLength.toString() +
            " characters";
        } else {
          setFormIsValid(false);
          newHelperText[propName] = schema.errorMessage;
          setErrorState({ ...errorState, [propName]: true });
        }
      }
    }
    setHelperText(newHelperText);
    setRegex(newRegex);
    setInput(newInput);
    setErrorState(newErrorState);
    setInitialized(newInitialized);
  }

  function getSchema(propName) {
    const schema = _.has(pathids.getSchema(), [propName])
      ? pathids.getSchema()[propName]
      : {
          type: "",
          label: "",
          dropdownOptions: [["", ""]],
          regex: null,
          errorMessage: "",
        };
    return schema;
  }

  function change(newValue, propName) {
    if (getSchema(propName) == null) {
      return;
    }
    const schema = getSchema(propName);
    setInitialized({ ...initialized, [propName]: true });
    if (validateField(newValue, propName, schema.type)) {
      setFormIsValid(true);
      if (schema.type === propertyTypes.OPEN_INPUT) {
        setHelperText({
          ...helperText,
          [propName]:
            schema.minLength.toString() +
            "-" +
            schema.maxLength.toString() +
            " characters",
        });
      }
      setErrorState({ ...errorState, [propName]: false });
    } else {
      setFormIsValid(false);
      if (schema.type) {
        setHelperText({ ...helperText, [propName]: schema.errorMessage });
      }
      setErrorState({ ...errorState, [propName]: true });
      if (schema.type === propertyTypes.SELECT_OPTION) {
        return;
      }
    }
    setInput({ ...input, [propName]: newValue });
  }

  async function submitForm() {
    try {
      api.requireApiSuccess(
        await api.post(
          `user.${pathids.ids.user}/${pathname}.${pathids.ids.user}`,
          {
            ...input,
          }
        )
      );
    } catch (e) {
      if (e instanceof ApiError) {
        alert(e.message);
        console.log(e.message);
        // setFormErrorMessage(e.message);
        return false;
      } else {
        alert("Something went wrong. Please try again later.");
        // setFormErrorMessage("Something went wrong. Please try again later.");
        throw e;
      }
    }
    window.location.reload();
  }

  return {
    startForm,
    change,
    getValue,
    getError,
    getErrorMessage,
    getLabel,
    getTitle,
    getSchema,
    getDropdownOptions,
    submitForm,
    getTextInputValue,
    formIsValid,
    getHelperText,
  };
}

export default useDialogWebFormMultiItems;
